export const styles = {
  precourseCardRoot: (isMobile) => ({
    backgroundColor: 'kit.background.white',
    width: '100%',
    height: 'auto',
    padding: { xs: '16px 16px 24px 16px;', lg: '24px 32px;' },
    ...(isMobile ? { mt: 4 } : {}),
  }),
  precourseCardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  precourseCardTitleNoDescription: (theme) => ({
    mt: 2,
    fontWeight: 700,
    [theme.breakpoints.up('lg')]: {
      mt: 0,
      fontSize: 24,
      display: 'flex',
      gap: 3,
    },
  }),
  precourseCardTitle: (theme) => ({
    mt: 2,
    fontWeight: 700,
    [theme.breakpoints.up('lg')]: {
      mt: 4,
      fontSize: 24,
      display: 'flex',
      gap: 3,
    },
  }),
  precourseCardStatus: {
    color: 'kit.text.secondary',
    backgroundColor: 'kit.background.middlepurple',
    border: 'none',
    textTransform: 'none',
    fontWeight: 400,
    width: 'fit-content',
    fontFamily: 'Inter',
    fontSize: { xs: 11, lg: 14 },

    padding: { xs: 0.5, lg: 1 },
    minWidth: { xs: 'none', lg: 78 },
    height: { xs: 'inherit', lg: 'fit-content' },
  },
  precourseCardDuration: (theme) => ({
    mt: 2,
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    fontSize: 14,
    [theme.breakpoints.up('lg')]: {
      mt: 3,
      fontSize: 18,
    },
  }),
  precourseCardStart: {
    mt: 4,
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
  },
  precourseCardIcon: { width: { xs: 16, lg: 24 }, height: { xs: 16, lg: 24 } },
  precourseCardPrice: {
    mt: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: { xs: 18, lg: 22 },
  },
};
